export class ImportResult {
    ValidCount: number = 0;
    unValidCount: number = 0;
    RepeatCount: number = 0;
    unValidFileId: string;
    ValidBulkErrorMessage: string;
    ValidBulk: boolean;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/import.ts